import { useSearchParams } from "react-router-dom";
import ProfileDetails from "./profile-details";
import { useAuth } from "hooks/useAuth";
import SecurityForm from "./security-form";
import NotificationSettings from "./notifications";
import OrganizationSettings from "./organization-settings";
import IntegrationSettings from "./integrations";
import DevicesManagement from "./devices";
import IntegrationSetting from "./integration-setting";

const Settings = (props) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get("tab") || "details"; // Default to "details"
  const { user } = useAuth();

  const handleTabChange = (tabName) => {
    setSearchParams({ tab: tabName });
  };

  return (
    <div className="mt-3 gap-2 rounded-[20px] flex flex-col">
      {/* Tab pane */}
      <div className="flex gap-1 rounded-2xl bg-gray-50 dark:bg-navy-700 p-1 mb-[8px] whitespace-nowrap flex-nowrap overflow-x-auto">
        {[
          { key: "details", label: "Profile details" },
          { key: "security", label: "Security" },
          { key: "notifications", label: "Notifications" },
          { key: "organization", label: "Organization" },
          { key: "integrations", label: "Integrations" },
          { key: "integration_settings", label: "Integration settings" },
          { key: "devices", label: "Device management" },
          // { key: "devices", label: "devices" },
        ].map(({ key, label }) => (
          <button
            key={key}
            className={`inline-block px-4 py-2 font-bold rounded-2xl ${
              tab === key
                ? "bg-white text-gray-800 dark:bg-background-900 dark:text-white"
                : "bg-none text-gray-700 dark:text-gray-600"
            }`}
            onClick={() => handleTabChange(key)}
          >
            {label}
          </button>
        ))}
      </div>

      <div className="flex flex-row flex-wrap gap-3">
        {tab === "details" && <ProfileDetails user={user} />}
        {tab === "security" && <SecurityForm />}
        {tab === "notifications" && <NotificationSettings />}
        {tab === "organization" && <OrganizationSettings />}
        {tab === "integrations" && <IntegrationSettings />}
        {tab === "devices" && <DevicesManagement />}
        {tab === "integration_settings" && <IntegrationSetting />}
      </div>
    </div>
  );
};

export default Settings;
